exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client>div[data-v-5c2d1d2f]{-webkit-transform:translateY(-25%);transform:translateY(-25%)}", ""]);

// exports
